package one.healthium.profile.ui.components

import androidx.compose.foundation.layout.RowScope
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import one.healthium.ui.compose.components.AppSwipeToDeleteContainer

@Composable
internal fun SwipeToDismissContainer(
    modifier: Modifier = Modifier,
    onDelete: () -> Unit,
    content: @Composable RowScope.() -> Unit,
) {
    AppSwipeToDeleteContainer(
        modifier = modifier,
        onDelete = onDelete,
        content = content,
    )
}
